import { render, staticRenderFns } from "./AudioRecorder.vue?vue&type=template&id=15febd18&scoped=true"
import script from "./AudioRecorder.vue?vue&type=script&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&lang=js"
import style0 from "./AudioRecorder.vue?vue&type=style&index=0&id=15febd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15febd18",
  null
  
)

export default component.exports